import axios from "axios";



const API = axios.create({

    baseURL: `${process.env.REACT_APP_BACKEND_URI}/api/employees`

});









// GET ALL EMPLOYEES

export const getEmployees = async(

    search = "",

    managerId = null,

    roleName = ""

)=>{


    const response = await API.get(

        "/",

        {

            params:{

                search,

                manager_id: managerId,

                role_name: roleName

            }

        }

    );


    return response.data;


};









// GET SINGLE EMPLOYEE

export const getEmployee = async(

    employeeId

)=>{


    const response = await API.get(

        `/${employeeId}`

    );


    return response.data;


};









// CREATE EMPLOYEE

export const createEmployee = async(

    data

)=>{


    const response = await API.post(

        "/",

        data

    );


    return response.data;


};









// UPDATE EMPLOYEE

export const updateEmployee = async(

    employeeId,

    data

)=>{


    const response = await API.put(

        `/${employeeId}`,

        data

    );


    return response.data;


};









// DELETE EMPLOYEE

export const deleteEmployee = async(

    employeeId,

    deleteRelated = false

)=>{


    const response = await API.delete(

        `/${employeeId}`,

        {

            params:{

                delete_related: deleteRelated

            }

        }

    );


    return response.data;


};







// SYNC EMPLOYEES FROM AZURE AD

export const syncEmployeesFromAzure = async (employeeId = null) => {

    // The sync now runs in the background on the server and returns
    // immediately; completion is announced via an in-app notification.
    const response = await API.post("/sync-azure", null, {
        params: { employee_id: employeeId }
    });

    return response.data;

};




export default API;